import React from 'react';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './ToastNotification.module.css';
import {Zoom, Slide} from 'react-toastify';

// Error Toast
export const showErrorToast = (message) => {
    toast.error(message, {
        newestOnTop: true,
        position: "top-left", // Options: top-right, top-center, top-left, bottom-right, bottom-center, bottom-left
        autoClose: 5000, // Duration in milliseconds
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined, // Control progress bar manually
        icon: <span>⚠️</span>, // Custom icon
        theme: "dark", // Options: light, dark, colored
        className: styles['my-custom-toast'], // Custom CSS class
        progressClassName: styles['my-custom-progress-bar'], // Custom progress bar style
        transition: Slide, // Animation effect
    });
};

// Success Toast
export const showSuccessToast = (message) => {
    toast.success(message, {
        newestOnTop: true,
        position: "bottom-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: <span>✔️</span>,
        theme: "light",
        className: styles['my-custom-toast'],
        progressClassName: styles['my-custom-progress-bar'],
        transition: Slide,
    });
};

// Info Toast
export const showInfoToast = (message) => {
    toast.info(message, {
        newestOnTop: true,
        position: "bottom-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: <span>⚠️</span>,
        theme: "light",
        className: styles['my-custom-toast'],
        progressClassName: styles['my-custom-progress-bar'],
        transition: Slide,
    });
};

// Warning Toast
export const showWarningToast = (message) => {
    toast.warn(message, {
        newestOnTop: true,
        position: "top-left",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        icon: <span>⚠️</span>,
        theme: "dark",
        className: styles['my-custom-toast'],
        progressClassName: styles['my-custom-progress-bar'],
        transition: Slide,
    });
};

// Default Toast
export const showDefaultToast = (message) => {
    toast(message, {
        newestOnTop: true,
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        className: styles['my-custom-toast'],
        progressClassName: styles['my-custom-progress-bar'],
        transition: Slide,
    });
};
